<div class="logout-container">
  <p>Logging out</p>
</div>
